import React from "react";
import {FormControlLabel, FormLabel, Radio, RadioGroup} from "@mui/material";
import {objects, strings} from "@atttomyx/shared-utils";
import {themes} from "@atttomyx/shared-constants";
import {LAYOUT_HORIZONTAL, LAYOUT_VERTICAL, VIEW_CARDS, VIEW_GRAPH} from "../../constants";
import "./userSettingsForm.css";

const UserSettingsForm = (props) => {
    const { data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = strings.isNotBlank(modified.theme)
            && strings.isNotBlank(modified.view)
            && strings.isNotBlank(modified.layout);

        onSync(modified);
    };

    return <div className="user-settings-form">
        <div className="option">
            <FormLabel id="theme">Theme</FormLabel>
            <RadioGroup row={true} aria-labelledby="theme"
                        onChange={(event) => onChange("theme", event.target.value)}>
                <FormControlLabel
                    value={themes.LIGHT}
                    label="Light"
                    control={<Radio checked={data.theme === themes.LIGHT} color="primary"/>}
                />
                <FormControlLabel
                    value={themes.DARK}
                    label="Dark"
                    control={<Radio checked={data.theme === themes.DARK} color="primary"/>}
                />
            </RadioGroup>
        </div>
        <div className="option">
            <FormLabel id="view">Default View</FormLabel>
            <RadioGroup row={true} aria-labelledby="view"
                        onChange={(event) => onChange("view", event.target.value)}>
                <FormControlLabel
                    value={VIEW_GRAPH}
                    label="Graph"
                    control={<Radio checked={data.view === VIEW_GRAPH} color="primary"/>}
                />
                <FormControlLabel
                    value={VIEW_CARDS}
                    label="Cards"
                    control={<Radio checked={data.view === VIEW_CARDS} color="primary"/>}
                />
            </RadioGroup>
        </div>
        <div className="option">
            <FormLabel id="layout">Default Layout</FormLabel>
            <RadioGroup row={true} aria-labelledby="layout"
                        onChange={(event) => onChange("layout", event.target.value)}>
                <FormControlLabel
                    value={LAYOUT_HORIZONTAL}
                    label="Horizontal"
                    control={<Radio checked={data.layout === LAYOUT_HORIZONTAL} color="primary"/>}
                />
                <FormControlLabel
                    value={LAYOUT_VERTICAL}
                    label="Vertical"
                    control={<Radio checked={data.layout === LAYOUT_VERTICAL} color="primary"/>}
                />
            </RadioGroup>
        </div>
    </div>
}

export default UserSettingsForm;
